import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const usePartnerQuery = ({ partner_id }) => {
  return useQuery({
    queryKey: QUERY_KEYS.partnerById(partner_id),
    queryFn: () =>
      query({ query: 'getPartner', variables: { id: partner_id } }),
    enabled: !!partner_id
  })
}
